import Vue from 'vue';
import VueRouter from 'vue-router';
// import api from '../server/apiSite'
// import axios from 'axios'
// 进度条
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

import util, { loginByCSDNCodeFun } from '@/libs/util';
import { SINGLE_TOKEN_KEY, SINGLE_UUID_KEY } from '@/maps/common';
// 路由数据
import routes from './routes';
import mobileRoutes from './mobileRoutes';

const isMobile = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const mobileKeywords =
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;

  return mobileKeywords.test(userAgent);
};

// fix vue-router NavigationDuplicated
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return VueRouterPush.call(this, location).catch(err => err);
};
const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return VueRouterReplace.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

// 导出路由 在 main.js 里使用
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: isMobile() ? mobileRoutes : routes,
});

// 辅助函数：递归平铺路由并拼接完整路径
function flattenRoutes(routes, parentPath = '') {
  return routes.reduce((acc, route) => {
    const fullPath = parentPath + (route.path.startsWith('/') ? route.path : `/${route.path}`);
    acc.push({ ...route, path: fullPath });
    if (route.children) {
      acc.push(...flattenRoutes(route.children, fullPath));
    }
    return acc;
  }, []);
}

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach(async (to, from, next) => {
  const { meta: toMeta = {}, path: toPath, query } = to;
  const { auth = false } = toMeta;
  // 进度条
  NProgress.start();
  console.log(query);
  const { partner, platform, code, redirect, cross_web_ticket, cross_web_uuid } = query;

  if (cross_web_ticket && cross_web_uuid) {
    util.cookies.set(SINGLE_TOKEN_KEY, cross_web_ticket, {
      expires: 604800 / 24 / 3600,
      domain: '.mg.xyz',
    });
    util.cookies.set(SINGLE_UUID_KEY, cross_web_uuid, {
      expires: 604800 / 24 / 3600,
      domain: '.mg.xyz',
    });
    if (redirect) {
      window.open(redirect, '_self');
    } else {
      delete query.cross_web_ticket;
      delete query.cross_web_uuid;
      next({ path: toPath, query });
    }
  }

  // 如果是从CSDN授权登录过来的，直接通过code进行登录
  if (platform && platform === 'csdn' && code) {
    await loginByCSDNCodeFun(code);
    if (redirect) {
      window.open(redirect, '_self');
    } else {
      next({ path: '/home' });
    }
  }
  let auth1 = true; // 如果存在之前的登录数据，且token过期是，这个值用来控制token登录接口是否提示登录失败提示和登录失败后是否返回首页
  // 支付页面时不需要提示且不需要跳转
  if(toPath === '/pay'){
    auth1 = false;
  }
  const token = await util.getToken(auth1);
  // 处理合作商标识
  if (partner) {
    localStorage.setItem('partner', partner);
  }

  // 特殊处理hutb路径，即使在手机环境下也不使用mobile路由
  if (toPath.includes('hutb')) {
    // 将工商大学的标识写入到localStorage中
    localStorage.setItem('isHutb', 1);
    // 检查路径是否存在于常规路由中
    const validRoutes = flattenRoutes(routes);
    const routeExists = validRoutes.some(route => route.path === toPath);

    if (!routeExists) {
      next({ path: '/home' });
      return;
    }

    if (token) {
      util.jumpSpace('_self');
      return;
    } else {
      // 未登录也留在hutb页面，不进行重定向
      next();
      return;
    }
  } else {
    localStorage.removeItem('isHutb');
    // 其他路径正常处理
    const validRoutes = flattenRoutes(isMobile() ? mobileRoutes : routes);
    const routeExists = validRoutes.some(route => route.path === toPath);

    if (!routeExists) {
      // 如果包含/blockchain,则重定向到/blockchain
      if (toPath.includes('/blockchain')) {
        next({ path: '/blockchain' });
        return;
      }
      const redirectPath = isMobile() ? '/mobile/home' : '/home';
      next({ path: redirectPath });
      return;
    }
  }

  if (token) {
    next();
  } else {
    // 需要登录则跳转到登录页
    if (auth && !isMobile()) {
      router.push({
        path: '/login',
        query: {
          redirect: encodeURIComponent(toPath),
        },
      });
    }
    next();
  }
});

router.afterEach(to => {
  // 进度条
  NProgress.done();
  // 更改标题
  util.setBomTitle(to.meta.title);
});

export default router;
